export default __webpack_public_path__ + "static/media/no-medication-list.1b3f20da.svg";